import styled from 'styled-components';
import { Colors } from '../../utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.light?.environment.lighter};
`;
